import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { CompanyLookupResult, CompanySearchResult } from '../models/data-model';
import { RegistrationApiService } from './registration-api.service';

export type CompanySearchMode = 'name' | 'registrationNumber';
export type CompanySearchError = 'noResults' | 'invalidFormat' | 'tooManyResults' | 'providerUnreachable';

@Injectable({
    providedIn: 'root'
})
export class CompanySearchService {
    private lookupResult: CompanyLookupResult;
    private kybProviderId: string;

    constructor(
        private readonly registrationApiService: RegistrationApiService,
        private readonly logger: NGXLogger
    ) {}

    search(term: string, countryIso3: string, mode: CompanySearchMode): Promise<CompanySearchResult> {
        if (!term) {
            this.logger.debug("Search term is missing");
            return null;
        }
        if (mode === 'registrationNumber') {
            return this.registrationApiService.searchCompanyByRegistrationNumber(term, countryIso3);
        }
        return this.registrationApiService.searchCompanyByName(term, countryIso3);
    }

    lookup(kybProviderId: string, countryIso3: string): Promise<CompanyLookupResult> {
        if (!kybProviderId) {
            this.logger.debug("kybProviderId is missing");
            return null;
        }
        return this.registrationApiService.lookupCompany(kybProviderId, countryIso3);
    }

    setKybProviderId(kybProviderId: string) {
        this.kybProviderId = kybProviderId;
    }

    setCompanyLookupResult(result: CompanyLookupResult): void {
        this.lookupResult = result;
    }

    getCachedLookupResult(): CompanyLookupResult {
        return this.lookupResult;
    }

    getCompanyLookupResult(countryIso3: string, kybProviderId?: string): Promise<CompanyLookupResult> {
        if (this.kybProviderId) {
            kybProviderId = this.kybProviderId;
        }
        if (this.lookupResult?.kybProviderId === kybProviderId) {
            return Promise.resolve(this.lookupResult);
        }
        return this.lookup(kybProviderId, countryIso3);
    }
}
